var map = {
	"./": [
		5772,
		9
	],
	"./en-AU-AnnetteNeural.mp3": [
		949,
		1,
		949
	],
	"./en-AU-CarlyNeural.mp3": [
		7225,
		1,
		225
	],
	"./en-AU-DarrenNeural.mp3": [
		6446,
		1,
		446
	],
	"./en-AU-DuncanNeural.mp3": [
		1410,
		1,
		410
	],
	"./en-AU-ElsieNeural.mp3": [
		1894,
		1,
		894
	],
	"./en-AU-FreyaNeural.mp3": [
		8538,
		1,
		538
	],
	"./en-AU-JoanneNeural.mp3": [
		9710,
		1,
		710
	],
	"./en-AU-KenNeural.mp3": [
		9982,
		1,
		982
	],
	"./en-AU-KimNeural.mp3": [
		5677,
		1,
		677
	],
	"./en-AU-NatashaNeural.mp3": [
		6246,
		1,
		246
	],
	"./en-AU-NeilNeural.mp3": [
		9871,
		1,
		871
	],
	"./en-AU-TimNeural.mp3": [
		337,
		1,
		337
	],
	"./en-AU-TinaNeural.mp3": [
		2093,
		1,
		93
	],
	"./en-AU-WilliamNeural.mp3": [
		3990,
		1,
		990
	],
	"./en-US-AmberNeural.mp3": [
		1384,
		1,
		384
	],
	"./en-US-AnaNeural.mp3": [
		7884,
		1,
		884
	],
	"./en-US-AriaNeural.mp3": [
		3103,
		1,
		103
	],
	"./en-US-AshleyNeural.mp3": [
		4901,
		1,
		901
	],
	"./en-US-BrandonNeural.mp3": [
		5306,
		1,
		306
	],
	"./en-US-ChristopherNeural.mp3": [
		9702,
		1,
		702
	],
	"./en-US-CoraNeural.mp3": [
		4383,
		1,
		383
	],
	"./en-US-DavisNeural.mp3": [
		6205,
		1,
		205
	],
	"./en-US-ElizabethNeural.mp3": [
		6415,
		1,
		415
	],
	"./en-US-EricNeural.mp3": [
		6113,
		1,
		113
	],
	"./en-US-GuyNeural.mp3": [
		5465,
		1,
		465
	],
	"./en-US-JacobNeural.mp3": [
		6638,
		1,
		638
	],
	"./en-US-JaneNeural.mp3": [
		4190,
		1,
		190
	],
	"./en-US-JasonNeural.mp3": [
		304,
		1,
		304
	],
	"./en-US-JennyMultilingualNeural.mp3": [
		4655,
		1,
		655
	],
	"./en-US-JennyNeural.mp3": [
		5417,
		1,
		417
	],
	"./en-US-MichelleNeural.mp3": [
		6979,
		1,
		979
	],
	"./en-US-MonicaNeural.mp3": [
		9400,
		1,
		400
	],
	"./en-US-NancyNeural.mp3": [
		7781,
		1,
		781
	],
	"./en-US-RogerNeural.mp3": [
		4624,
		1,
		624
	],
	"./en-US-SaraNeural.mp3": [
		1919,
		1,
		919
	],
	"./en-US-SteffanNeural.mp3": [
		3526,
		1,
		526
	],
	"./en-US-TonyNeural.mp3": [
		395,
		1,
		395
	],
	"./index": [
		5772,
		9
	],
	"./index.ts": [
		5772,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5509;
module.exports = webpackAsyncContext;